import { Badge, ThemeColor } from '@rematter/ui-web';

import { runtimeConfig } from '~/config/runtime';

const environmentVariants: Record<string, ThemeColor> = {
  alpha: 'success',
  staging: 'warning',
  ephemeral: 'primary',
  development: 'teal',
};

const environmentLabels: Record<string, string> = {
  alpha: 'Alpha',
  staging: 'Staging',
  ephemeral: 'Ephemeral',
  development: 'Dev',
};

export const EnvironmentTag = () => {
  const isProduction = runtimeConfig.environment === 'production';
  const label = environmentLabels[runtimeConfig.environment];

  if (isProduction || !label) {
    return null;
  }

  return (
    <Badge
      className="@EnvironmentTag !text-[0.5em]"
      color={environmentVariants[runtimeConfig.environment] ?? 'neutral'}
      size="xs"
    >
      {environmentLabels[runtimeConfig.environment]}
    </Badge>
  );
};
